import request from "@/utils/request";
import { Toast } from "vant";

const lesseeContract = {
  state: {
    contractInfo: null,
    propertyInfo: null,
    contactInfo: null,
    position: 0
  },
  mutations: {
    SAVE_POSITION: (state, position) => {
      state.position = position;
    },
    SET_CONTRACT_INFO: (state, contractInfo) => {
      state.contractInfo = contractInfo;
    },
    SET_CONTACT_INFO: (state, contactInfo) => {
      state.contactInfo = contactInfo;
    },
    SET_PROPERTY_INFO: (state, propertyInfo) => {
      state.propertyInfo = propertyInfo;
    },
    CLEAR: state => {
      state.contractInfo = null;
      state.propertyInfo = null;
      state.contactInfo = null;
    }
  },
  actions: {}
};

export default lesseeContract;
